import { render, staticRenderFns } from "./Destinos_toneladas.vue?vue&type=template&id=599ffc2e"
import script from "./Destinos_toneladas.vue?vue&type=script&lang=js"
export * from "./Destinos_toneladas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports